export default {
  namespaced: true,
  state: {
    isOpened: false,
  },
  getters: {
    getIsOpened (state) {
      return state.isOpened
    } 
  },
  mutations: {
    setIsOpened (state, isOpened) {
      state.isOpened = isOpened
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/portal.js